module.exports = __webpack_public_path__ + "static/image11-1b0f3a0a89f8a36f6fcfd604c13a6898.png";